import { render } from "./InsertGrade.vue?vue&type=template&id=237d8eba&scoped=true"
import script from "./InsertGrade.vue?vue&type=script&lang=js"
export * from "./InsertGrade.vue?vue&type=script&lang=js"

import "./InsertGrade.vue?vue&type=style&index=0&id=237d8eba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-237d8eba"]])

export default __exports__